/*
 * Countdown-Aktion — Tick-Logik für sections/countdown-aktion.liquid
 *
 * Wird auch von blocks/aktion-countdown.liquid (PDP) und der Aktionskarte in
 * sections/hero-welcome.liquid benutzt.
 *
 * Das Element liefert die Deadline als absolute Epoch (data-end-ts), nie als
 * Wanduhrzeit. Damit sieht jeder Besucher dieselbe Restzeit, egal in welcher
 * Zeitzone sein Gerät steht.
 *
 * Ein einziges Interval für alle Instanzen. Muss idempotent sein: der
 * Theme-Editor injiziert die Section bei jeder Setting-Änderung neu, sonst
 * stapeln sich Intervalle und die Sekunden springen in 2er-Schritten.
 */
(function () {
  'use strict';

  if (window.__countdownAktionInit) return;
  window.__countdownAktionInit = true;

  var SELECTOR = '[data-countdown-aktion]';
  var timer = null;

  function pad(n) {
    return n < 10 ? '0' + n : String(n);
  }

  function set(el, unit, value) {
    var node = el.querySelector('[data-unit="' + unit + '"]');
    if (!node) return;
    var next = pad(value);
    // Nur schreiben, wenn sich etwas ändert — spart Repaints im Sekundentakt.
    if (node.textContent !== next) node.textContent = next;
  }

  /*
   * Weicht die Uhr des Besuchers stark von der Serverzeit ab, ist nicht der
   * Cache schuld, sondern die Uhr. Cache-Alter liegt bei Sekunden bis Minuten,
   * eine falsch gestellte Uhr bei Stunden — deshalb erst ab 10 Minuten
   * korrigieren.
   */
  function skewFor(el) {
    var serverNow = parseInt(el.getAttribute('data-server-now'), 10);
    if (!serverNow) return 0;
    var skew = serverNow * 1000 - Date.now();
    return Math.abs(skew) > 600000 ? skew : 0;
  }

  function tick() {
    var nodes = document.querySelectorAll(SELECTOR);
    if (!nodes.length) {
      clearInterval(timer);
      timer = null;
      return;
    }

    Array.prototype.forEach.call(nodes, function (el) {
      var end = parseInt(el.getAttribute('data-end-ts'), 10);
      if (!end) return;

      var remaining = end * 1000 - (Date.now() + skewFor(el));

      if (remaining <= 0) {
        // Im Theme-Editor stehen lassen, sonst ist die Section nicht mehr bearbeitbar.
        if (window.Shopify && window.Shopify.designMode) {
          set(el, 'days', 0); set(el, 'hours', 0);
          set(el, 'minutes', 0); set(el, 'seconds', 0);
          return;
        }
        // data-countdown-self: nur das Element selbst entfernen (PDP-Block,
        // Hero-Karte) — sonst nähme closest() die ganze Produkt- bzw. Hero-Section mit.
        var wrapper = el.hasAttribute('data-countdown-self')
          ? el
          : el.closest('.shopify-section') || el;
        wrapper.remove();
        return;
      }

      var total = Math.floor(remaining / 1000);
      set(el, 'days', Math.floor(total / 86400));
      set(el, 'hours', Math.floor((total % 86400) / 3600));
      set(el, 'minutes', Math.floor((total % 3600) / 60));
      set(el, 'seconds', total % 60);
    });
  }

  function start() {
    if (!document.querySelector(SELECTOR)) return;
    tick();
    if (timer) clearInterval(timer);
    timer = setInterval(tick, 1000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  // Hintergrund-Tabs drosseln Timer — beim Zurückkommen sofort nachziehen.
  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) start();
  });

  // Zurück-Navigation aus dem bfcache liefert einen eingefrorenen Stand.
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) start();
  });

  document.addEventListener('shopify:section:load', start);
  document.addEventListener('shopify:section:unload', function () {
    if (!document.querySelector(SELECTOR) && timer) {
      clearInterval(timer);
      timer = null;
    }
  });
})();
